/*
 * Dope Direct BC compliance helpers (unpublished build theme).
 * 1. 19+ age gate on entry. The date of birth is checked in the browser only and never sent or stored;
 *    after a pass, a 'verified' flag with a 30-day expiry is kept in localStorage (dd_age_verified).
 * 2. Checkout gate: every [data-dd-checkout] button stays disabled until the three boxes
 *    (19+, terms, privacy) are ticked and no [data-dd-gate] reports data-dd-blocked="true"
 *    (over 30 g dried-cannabis equivalent, or an item with unknown weight).
 * 3. "Added to cart" popup with the order-limit summary, loaded with the Section Rendering API.
 *
 * This is browser-side only. A determined user can bypass it by going to /checkout directly.
 * Server-side enforcement needs a cart and checkout validation function from an App Store app.
 */
(function () {
  'use strict';

  var AGE = 19;
  var AGE_KEY = 'dd_age_verified';
  var AGE_DAYS = 30;
  var CHECK_KEY = 'dd_checks';
  var CHECKS = ['age', 'terms', 'privacy'];

  /* ---------- 1. Age gate ---------- */

  function ageVerified() {
    try {
      var v = localStorage.getItem(AGE_KEY);
      return !!v && Number(v) > Date.now();
    } catch (e) {
      return false;
    }
  }

  function initAgeGate() {
    var gate = document.getElementById('dd-age-gate');
    if (!gate) return;
    if (ageVerified()) {
      gate.hidden = true;
      return;
    }
    gate.hidden = false;
    document.documentElement.classList.add('dd-age-locked');
    var form = gate.querySelector('[data-dd-age-form]');
    var err = gate.querySelector('[data-dd-age-error]');
    var inputs = form ? Array.prototype.slice.call(form.querySelectorAll('[data-dd-dob]')) : [];
    // Do not auto-focus on touch screens: it pops the keypad over the gate before the text is read.
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (inputs[0] && !coarse) inputs[0].focus();

    // Digits only, auto-advance Year -> Month -> Day when a field is full, Backspace goes back.
    inputs.forEach(function (input, i) {
      input.addEventListener('input', function () {
        var clean = input.value.replace(/[^0-9]/g, '');
        if (clean !== input.value) input.value = clean;
        err.hidden = true;
        if (clean.length >= Number(input.maxLength) && inputs[i + 1]) inputs[i + 1].focus();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !input.value && inputs[i - 1]) inputs[i - 1].focus();
      });
      input.addEventListener('focus', function () {
        // Keep the field and the Enter button above the on-screen keypad.
        setTimeout(function () {
          try { input.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {}
        }, 250);
      });
    });

    function showError(msg) {
      err.textContent = msg;
      err.hidden = false;
      try { err.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {}
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var y = parseInt(form.year.value, 10);
      var m = parseInt(form.month.value, 10);
      var d = parseInt(form.day.value, 10);
      var now = new Date();
      var dob = new Date(y, m - 1, d);
      var valid =
        y > 1900 && y <= now.getFullYear() && m >= 1 && m <= 12 && d >= 1 && d <= 31 &&
        dob.getFullYear() === y && dob.getMonth() === m - 1 && dob.getDate() === d && dob <= now;
      if (!valid) {
        showError('Please enter a valid date of birth (YYYY, MM, DD).');
        return;
      }
      var age = now.getFullYear() - y;
      if (now.getMonth() < m - 1 || (now.getMonth() === m - 1 && now.getDate() < d)) age -= 1;
      // Clear the typed date right away; it is never stored or sent.
      form.reset();
      if (age < AGE) {
        showError('Sorry, you must be 19 years of age or older to enter this site.');
        return;
      }
      try {
        localStorage.setItem(AGE_KEY, String(Date.now() + AGE_DAYS * 86400000));
      } catch (e) {}
      gate.hidden = true;
      document.documentElement.classList.remove('dd-age-locked');
    });
  }

  /* ---------- 2. Checkout gate ---------- */

  function readChecks() {
    try {
      return JSON.parse(sessionStorage.getItem(CHECK_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeChecks(state) {
    try {
      sessionStorage.setItem(CHECK_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  function allChecked(state) {
    return CHECKS.every(function (k) {
      return state[k] === true;
    });
  }

  function cartBlocked() {
    var gates = document.querySelectorAll('[data-dd-gate]');
    for (var i = 0; i < gates.length; i++) {
      if (gates[i].getAttribute('data-dd-blocked') === 'true') return true;
    }
    return false;
  }

  function canCheckout() {
    return allChecked(readChecks()) && !cartBlocked();
  }

  var syncing = false;
  function sync() {
    if (syncing) return;
    syncing = true;
    var state = readChecks();
    document.querySelectorAll('[data-dd-check]').forEach(function (box) {
      var want = state[box.getAttribute('data-dd-check')] === true;
      if (box.checked !== want) box.checked = want;
    });
    var ok = allChecked(state) && !cartBlocked();
    document.querySelectorAll('[data-dd-checkout]').forEach(function (btn) {
      if (ok) {
        btn.removeAttribute('disabled');
        btn.classList.remove('dd-is-disabled');
        btn.removeAttribute('aria-disabled');
      } else {
        btn.setAttribute('disabled', '');
        btn.classList.add('dd-is-disabled');
        btn.setAttribute('aria-disabled', 'true');
      }
    });
    if (ok) {
      document.querySelectorAll('[data-dd-message]').forEach(function (m) {
        m.hidden = true;
      });
    }
    syncing = false;
  }

  function showGateMessage() {
    document.querySelectorAll('[data-dd-message]').forEach(function (m) {
      m.hidden = false;
    });
    var firstUnchecked = document.querySelector('[data-dd-check]:not(:checked)');
    if (firstUnchecked && firstUnchecked.offsetParent !== null) firstUnchecked.focus();
  }

  function isCheckoutTarget(el) {
    if (!el) return false;
    if (el.matches && el.matches('[name="checkout"], [data-dd-checkout]')) return true;
    var a = el.closest && el.closest('a[href]');
    return !!(a && /\/checkouts?(\/|$|\?)/.test(a.getAttribute('href')));
  }

  function initCheckoutGate() {
    document.addEventListener('change', function (evt) {
      var box = evt.target;
      if (!box || !box.matches || !box.matches('[data-dd-check]')) return;
      var state = readChecks();
      state[box.getAttribute('data-dd-check')] = box.checked;
      writeChecks(state);
      sync();
    });

    // Guard clicks and form submits that would reach checkout without the gate passing.
    document.addEventListener(
      'click',
      function (evt) {
        var t = evt.target && evt.target.closest ? evt.target.closest('button, a, input[type="submit"]') : null;
        if (isCheckoutTarget(t) && !canCheckout()) {
          evt.preventDefault();
          evt.stopPropagation();
          showGateMessage();
        }
      },
      true
    );
    document.addEventListener(
      'submit',
      function (evt) {
        var submitter = evt.submitter;
        var action = (evt.target && evt.target.getAttribute('action')) || '';
        var toCheckout = (submitter && submitter.name === 'checkout') || /\/checkout/.test(action);
        if (toCheckout && !canCheckout()) {
          evt.preventDefault();
          evt.stopPropagation();
          showGateMessage();
        }
      },
      true
    );

    // Horizon re-renders the cart drawer and cart page after each change; re-apply state.
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        sync();
      });
    }).observe(document.body, { childList: true, subtree: true });

    sync();
  }

  /* ---------- 3. Added to cart popup ---------- */

  function initPopup() {
    var dialog = document.getElementById('dd-atc-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var body = dialog.querySelector('[data-dd-atc-body]');

    dialog.addEventListener('click', function (evt) {
      if (evt.target === dialog || (evt.target.closest && evt.target.closest('[data-dd-atc-close]'))) dialog.close();
    });

    document.addEventListener('cart:update', function (evt) {
      var detail = evt.detail || {};
      var data = detail.data || {};
      if (data.source !== 'product-form-component' || data.didError) return;
      var variantId = String(detail.sourceId || data.variantId || '');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart?sections=dd-atc-popup', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (json) {
          if (!json || !json['dd-atc-popup']) return;
          body.innerHTML = json['dd-atc-popup'];
          var match = body.querySelector('[data-dd-atc-variant="' + variantId + '"]');
          var items = body.querySelectorAll('[data-dd-atc-variant]');
          (match || items[items.length - 1] || { hidden: true }).hidden = false;
          // Close any open quick-add or cart drawer so only the popup shows.
          document.querySelectorAll('dialog[open]').forEach(function (d) {
            if (d !== dialog && !d.classList.contains('cart-drawer__dialog')) return;
            if (d !== dialog) d.close();
          });
          if (!dialog.open) dialog.showModal();
          sync();
        })
        .catch(function (e) {
          console.error('[dd] popup', e);
        });
    });
  }

  function start() {
    initAgeGate();
    initCheckoutGate();
    initPopup();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
